import {useState, useEffect} from 'react'
import usePostApi from '../../custom_hooks/usePostApi'
import {useThemeMode} from '../../../../_metronic/partials'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import * as Yup from 'yup'
import ThemeColors from '../ThemePref'
import Select, {components} from 'react-select'
import {KTIcon} from '../../../../_metronic/helpers'

const step2Schema = Yup.object().shape({
  pod_industry_id: Yup.string().required('Industry is required'),
})

const Step2 = ({set3rdIndex, data, setData}: any) => {
  const {execute} = usePostApi()
  const {mode} = useThemeMode()

  const [industries, setIndustries] = useState([])

  const getIndustries = async () => {
    try {
      const url = '/master/industries'
      const formData = {}

      const response = await execute(url, 'POST', formData)
      const options = (response.data || []).map((each: any) => ({
        value: each.industry_id,
        label: each.industry_en,
      }))
      setIndustries(options)
    } catch (error) {
      console.error('Error:', error)
    }
  }
  const [countryOptions, setCountryOptions] = useState([])

  const getCountries = async () => {
    try {
      const url = '/master/country'
      const formData = {}

      const response = await execute(url, 'POST', formData)
      const options = (response.data || []).map((each: any) => ({
        pref_date_format: each.pref_date_format,
        pref_timezone: each.pref_timezone,
        value: each.iso,
        label: each.name,
      }))
      setCountryOptions(options)
    } catch (error) {
      console.error('Error:', error)
    }
  }
  const [teamsizeOptions, setTeamSizeOptions] = useState([])

  const getDifferentTeamSizes = async () => {
    try {
      const url = '/lookup/TEAM_SIZE'
      const formData = {}

      const response = await execute(url, 'POST', formData)
      const options = (response.data || []).map((each: any) => ({
        value: each.lookup_code,
        label: each.meaning_en,
      }))
      setTeamSizeOptions(options)
    } catch (error) {
      console.error('Error:', error)
    }
  }

  useEffect(() => {
    getIndustries()
    getCountries()
    getDifferentTeamSizes()
  }, [])

  const [urlValid, setUrlValid] = useState(false)
  const [urlInput, setUrlInput] = useState(data.pod_website_url)

  const regex =
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/

  useEffect(() => {
    if (urlInput) {
      const isValid = regex.test(urlInput)
      if (isValid === false) {
        setUrlValid(true)
        return
      }
      setUrlValid(false)
    } else {
      setUrlValid(false)
    }
  }, [urlInput])

  const updateData = (value: string, key: string) => {
    setData({...data, [key]: value})
  }

  const onSubmit = (values: any) => {
    if (urlValid === true) {
      return
    }
    setData({...values})
    set3rdIndex()
  }

  const handleIndustryChange = (setFieldValue: any, selectedOption: any) => {
    if (selectedOption && selectedOption.value) {
      setFieldValue('pod_industry_id', selectedOption.value)
    } else {
      setFieldValue('pod_industry_id', '') // Handle case where no option is selected
    }
  }

  const handleCountryChange = (setFieldValue: any, selectedOption: any) => {
    if (selectedOption && selectedOption.value) {
      setFieldValue('pod_country_code', selectedOption.value)
      setFieldValue('timeZone', selectedOption.pref_timezone)
      setFieldValue('dateFormat', selectedOption.pref_date_format)
    } else {
      setFieldValue('pod_country_code', '') // Handle case where no option is selected
    }
  }

  const handleTeamsizeChange = (setFieldValue: any, selectedOption: any) => {
    if (selectedOption && selectedOption.value) {
      setFieldValue('pod_team_size', selectedOption.value)
    } else {
      setFieldValue('pod_team_size', '') // Handle case where no option is selected
    }
  }

  const dateFormatOptions = [
    {value: 'dd/MM/yyyy', label: 'DD/MM/YYYY'},
    {value: 'MM/dd/yyyy', label: 'MM/DD/YYYY'},
    {value: 'yyyy/MM/dd', label: 'YYYY/MM/DD'},
    {value: 'dd-MM-yyyy', label: 'DD-MM-YYYY'},
    {value: 'MM dd, yyyy', label: 'MM DD, YYYY'},
    {value: 'dd MMMM yyyy', label: 'DD Month YYYY'},
    {value: 'MM dd yyyy', label: 'MM DD YYYY'},
    {value: 'dd-MM-yy', label: 'DD-MM-YY'},
    {value: 'yy/MM/dd', label: 'YY/MM/DD'},
  ]

  const addCurrentDateToLabel = (format: any) => {
    const currentDate = new Date()

    const formattedDate = format
      .replace('dd', currentDate.getDate().toString().padStart(2, '0'))
      .replace('DD', currentDate.getDate().toString().padStart(2, '0'))
      .replace('MM', (currentDate.getMonth() + 1).toString().padStart(2, '0'))
      .replace('yyyy', currentDate.getFullYear())
      .replace('YYYY', currentDate.getFullYear())
      .replace('yy', currentDate.getFullYear().toString().slice(-2))
      .replace('YY', currentDate.getFullYear().toString().slice(-2))
      .replace('Month', new Intl.DateTimeFormat('en-US', {month: 'long'}).format(currentDate))

    return `${format} (${formattedDate})`
  }

  const dateFormatOptionsWithDate = dateFormatOptions.map((option) => ({
    ...option,
    label: addCurrentDateToLabel(option.label),
  }))

  const [timezones, setTimezones] = useState([])

  const getTimezones = async () => {
    try {
      const url = '/master/timezone'
      const formData = {}

      const response = await execute(url, 'POST', formData)
      const options = (response.data || []).map((each: any) => ({
        value: each.tz_name,
        label: each.tz_label,
      }))
      setTimezones(options)
    } catch (error) {
      console.error('Error:', error)
    }
  }

  useEffect(() => {
    getTimezones()
  }, [])

  const MultiLineOption = (props: any) => (
    <components.Option {...props}>
      <div>{props.data.label}</div>
      <div style={{fontSize: '12px', color: '#92929f'}}>{props.data.value}</div>
    </components.Option>
  )

  return (
    <Formik validationSchema={step2Schema} initialValues={data} onSubmit={onSubmit}>
      {({setFieldValue, values}: any) => {
        return (
          <Form className='w-100'>
            <div className='mb-5'>
              <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                <span className='required'>Industry</span>
                <i
                  className='fas fa-info-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Choose the industry your organization belongs to.'
                ></i>
              </label>
              <Select
                value={industries.find((option: any) => option.value === values.pod_industry_id)}
                styles={{
                  control: (baseStyles: any, state: any) => ({
                    ...baseStyles,
                    backgroundColor: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                    color: '#ffffff',
                    borderWidth: '0px',
                  }),
                  menu: (baseStyles: any) => ({
                    ...baseStyles,
                    backgroundColor: mode === 'dark' ? '#2b2b40' : '#f9f9f9',
                  }),
                  singleValue: (baseStyles: any, state: any) => ({
                    ...baseStyles,
                    color: mode === 'dark' ? '#92929f' : '#000000',
                  }),
                  input: (baseStyles: any) => ({
                    ...baseStyles,
                    color: mode === 'dark' ? '#92929f' : '#000000', // Color for the search text
                  }),
                  option: (baseStyles: any, {isFocused, isSelected}: any) => ({
                    ...baseStyles,
                    backgroundColor: isSelected
                      ? '#C2C2C2'
                      : isFocused
                      ? '#e0e0e0'
                      : baseStyles.backgroundColor,
                    color: isSelected ? '#000000' : isFocused ? '#000000' : baseStyles.color,
                  }),
                }}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 5,
                  backgroundColor: '#000000',
                  colors: {
                    ...theme.colors,
                    primary25: 'rgba(80, 107, 236, 0.5)',
                    primary: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                  },
                })}
                className='react-select-container'
                classNamePrefix='react-select'
                options={industries}
                isSearchable
                placeholder='Select your industry'
                onChange={(val: any) => handleIndustryChange(setFieldValue, val)}
              />

              <div className='text-danger mt-2'>
                <ErrorMessage name='pod_industry_id' />
              </div>
            </div>

            <div className='d-flex flex-column flex-lg-row gap-5 mb-5'>
              <div className='w-100 w-mg-50'>
                <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                  <span className=''>Date Format</span>
                  <i
                    className='fas fa-info-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Choose how you want dates to be displayed (e.g., DD/MM/YYYY, MM/DD/YYYY).'
                  ></i>
                </label>
                <Select
                  value={dateFormatOptionsWithDate.find(
                    (option: any) => option.value === data.dateFormat
                  )}
                  styles={{
                    control: (baseStyles: any, state: any) => ({
                      ...baseStyles,
                      backgroundColor: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                      color: '#ffffff',
                      borderWidth: '0px',
                    }),
                    menu: (baseStyles: any) => ({
                      ...baseStyles,
                      backgroundColor: mode === 'dark' ? '#2b2b40' : '#f9f9f9',
                    }),
                    singleValue: (baseStyles: any, state: any) => ({
                      ...baseStyles,
                      color: mode === 'dark' ? '#92929f' : '#000000',
                    }),
                    input: (baseStyles: any) => ({
                      ...baseStyles,
                      color: mode === 'dark' ? '#92929f' : '#000000',
                    }),
                    option: (baseStyles: any, {isFocused, isSelected}: any) => ({
                      ...baseStyles,
                      backgroundColor: isSelected
                        ? '#C2C2C2'
                        : isFocused
                        ? '#e0e0e0'
                        : baseStyles.backgroundColor,
                      color: isSelected ? '#000000' : isFocused ? '#000000' : baseStyles.color,
                    }),
                  }}
                  theme={(theme: any) => ({
                    ...theme,
                    borderRadius: 5,
                    backgroundColor: '#000000',
                    colors: {
                      ...theme.colors,
                      primary25: 'rgba(80, 107, 236, 0.5)',
                      primary: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                    },
                  })}
                  className='react-select-container'
                  classNamePrefix='react-select'
                  options={dateFormatOptionsWithDate}
                  isSearchable
                  placeholder='Select your preferred date format'
                  onChange={(val: any) => {
                    updateData(val?.value, 'dateFormat')
                  }}
                  // components={{Option: MultiLineOption}}
                />
              </div>
              <div className='w-100 w-mg-50'>
                <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                  <span className=''>Timezone</span>
                  <i
                    className='fas fa-info-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Choose the timezone your organization operates in.'
                  ></i>
                </label>
                <Select
                  value={timezones.find((option: any) => option.value === data.timeZone)}
                  styles={{
                    control: (baseStyles: any, state: any) => ({
                      ...baseStyles,
                      backgroundColor: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                      color: '#ffffff',
                      borderWidth: '0px',
                    }),
                    menu: (baseStyles: any) => ({
                      ...baseStyles,
                      backgroundColor: mode === 'dark' ? '#2b2b40' : '#f9f9f9',
                      // maxHeight: '160px',
                      // overflowY: 'scroll',
                    }),
                    singleValue: (baseStyles: any, state: any) => ({
                      ...baseStyles,
                      color: mode === 'dark' ? '#92929f' : '#000000',
                    }),
                    input: (baseStyles: any) => ({
                      ...baseStyles,
                      color: mode === 'dark' ? '#92929f' : '#000000', // Color for the search text
                    }),
                    option: (baseStyles: any, {isFocused, isSelected}: any) => ({
                      ...baseStyles,
                      backgroundColor: isSelected
                        ? '#C2C2C2'
                        : isFocused
                        ? '#e0e0e0'
                        : baseStyles.backgroundColor,
                      color: isSelected ? '#000000' : isFocused ? '#000000' : baseStyles.color,
                    }),
                  }}
                  theme={(theme: any) => ({
                    ...theme,
                    borderRadius: 5,
                    backgroundColor: '#000000',
                    colors: {
                      ...theme.colors,
                      primary25: 'rgba(80, 107, 236, 0.5)',
                      primary: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                    },
                  })}
                  className='react-select-container'
                  classNamePrefix='react-select'
                  options={timezones}
                  isSearchable
                  placeholder='Select your timezone'
                  onChange={(val: any) => {
                    // Check if the selected option value is already selected
                    const isAlreadySelected = data.timeZone === val?.value

                    // Update data only if the selected value is not already selected
                    if (!isAlreadySelected) {
                      updateData(val?.value, 'timeZone')
                    }
                  }}
                  components={{Option: MultiLineOption}} // Add this line to use the MultiLineOption component
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='pod_currency_code' />
                </div>
              </div>
            </div>

            {/* <div className='mb-5'>
              <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                <span className='required'>Country</span>
                <i
                  className='fas fa-info-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Choose the country where your organization is located.'
                ></i>
              </label>

              <Select
                value={countryOptions.find(
                  (option: any) => option.value === values.pod_country_code
                )}
                styles={{
                  control: (baseStyles: any, state: any) => ({
                    ...baseStyles,
                    backgroundColor: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                    color: '#ffffff',
                    borderWidth: '0px',
                  }),
                  menu: (baseStyles: any) => ({
                    ...baseStyles,
                    backgroundColor: mode === 'dark' ? '#2b2b40' : '#f9f9f9',
                  }),
                  singleValue: (baseStyles: any, state: any) => ({
                    ...baseStyles,
                    color: mode === 'dark' ? '#92929f' : '#000000',
                  }),
                  input: (baseStyles: any) => ({
                    ...baseStyles,
                    color: mode === 'dark' ? '#92929f' : '#000000', // Color for the search text
                  }),
                  option: (baseStyles: any, {isFocused, isSelected}: any) => ({
                    ...baseStyles,
                    backgroundColor: isSelected
                      ? '#C2C2C2'
                      : isFocused
                      ? '#e0e0e0'
                      : baseStyles.backgroundColor,
                    color: isSelected ? '#000000' : isFocused ? '#000000' : baseStyles.color,
                  }),
                }}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 5,
                  backgroundColor: '#000000',
                  colors: {
                    ...theme.colors,
                    primary25: 'rgba(80, 107, 236, 0.3)',
                    primary: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                  },
                })}
                className='react-select-container'
                classNamePrefix='react-select'
                options={countryOptions}
                isSearchable
                placeholder='Select your country'
                onChange={(val: any) => handleCountryChange(setFieldValue, val)}
              />
              <div className='text-danger'>
                <ErrorMessage name='pod_country_code' />
              </div>
            </div> */}

            {/* <div className='alert alert-danger d-flex align-items-center p-1'>
              <KTIcon iconName='information' className='fs-2 text-danger me-2' />
              <div className='d-flex flex-column'>
                <h6 className='mb-0 fw-semibold fs-7 text-dark'>Note:</h6>
                <span className='fs-8 text-dark'>
                  Please be advised that your country selection is final and cannot be modified
                  later. Please ensure careful consideration before making your country selection.
                </span>
              </div>
            </div> */}

            {/* <div className='mb-5'>
              <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                <span className=''>Team Size</span>
                <i
                  className='fas fa-info-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='The number of people in your organization.'
                ></i>
              </label>
              <Select
                value={teamsizeOptions.find((option: any) => option.value === values.pod_team_size)}
                styles={{
                  control: (baseStyles: any, state: any) => ({
                    ...baseStyles,
                    backgroundColor: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                    color: '#ffffff',
                    borderWidth: '0px',
                  }),
                  menu: (baseStyles: any) => ({
                    ...baseStyles,
                    backgroundColor: mode === 'dark' ? '#2b2b40' : '#f9f9f9',
                  }),
                  singleValue: (baseStyles: any, state: any) => ({
                    ...baseStyles,
                    color: mode === 'dark' ? '#92929f' : '#000000',
                  }),
                  input: (baseStyles: any) => ({
                    ...baseStyles,
                    color: mode === 'dark' ? '#92929f' : '#000000', // Color for the search text
                  }),
                  option: (baseStyles: any, {isFocused, isSelected}: any) => ({
                    ...baseStyles,
                    backgroundColor: isSelected
                      ? '#C2C2C2'
                      : isFocused
                      ? '#e0e0e0'
                      : baseStyles.backgroundColor,
                    color: isSelected ? '#000000' : isFocused ? '#000000' : baseStyles.color,
                  }),
                }}
                theme={(theme: any) => ({
                  ...theme,
                  borderRadius: 5,
                  backgroundColor: '#000000',
                  colors: {
                    ...theme.colors,
                    primary25: 'rgba(80, 107, 236, 0.5)',
                    primary: mode === 'dark' ? '#1b1b29' : '#f9f9f9',
                  },
                })}
                className='react-select-container'
                classNamePrefix='react-select'
                options={teamsizeOptions}
                isSearchable
                placeholder='Select your team size'
                onChange={(val: any) => handleTeamsizeChange(setFieldValue, val)}
              />
            </div> */}
            {/* <div className='mb-5'>
              <label className='d-flex align-items-center fs-6 fw-semibold form-label mb-2'>
                <span className=''>Website</span>
                <i
                  className='fas fa-info-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title="The web address of your organization's website."
                ></i>
              </label>
              <input
                className='form-control form-control-solid'
                placeholder='Enter your website URL'
                value={urlInput}
                onChange={(e: any) => {
                  setUrlInput(e.target.value)
                  setFieldValue('pod_website_url', e.target.value)
                }}
              />

              <div className='text-danger'>{urlValid && 'Please enter a valid URL'}</div>
            </div> */}

            <button
              type='submit'
              className='d-none btn btn-lg btn-primary w-100'
              id='step_2_submit'
            >
              Submit
            </button>
          </Form>
        )
      }}
    </Formik>
  )
}

export {Step2}
